
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  position: relative;
  margin: auto;
  display: block;
  aspect-ratio: 16 / 9;
  height: auto;
  width: 100%;
  overflow: hidden
}

.overlay {
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  z-index: 50;
  cursor: pointer;
  background-color: var(--neutral-black);
  background-size: cover;
  background-position: center;
  color: var(--neutral-white);
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms
}

.overlay-content {
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color:rgba(42, 41, 41, 0.4);
}

.overlay-content button{
    background-color:transparent;
    border:none;
  }

.overlay-content button idb-icon {
  cursor: pointer
}

.overlay-content button idb-icon {
  font-size: var(--fs-5xl);
  line-height: var(--lh-5xl)
}

.overlay-content button idb-icon {
  color: var(--neutral-white)
}

.overlay-content button idb-icon:hover {
  color: var(--blue-responsible-darken-2)
}

.video-container {
  height: 100%;
  width: 100%;
}

.video-container video {
  height: 100%
}

.video-container video {
  width: 100%
}

.video-container video {
  background-color: var(--neutral-black)
}

:host(.hero-slider-child) {
  height: 255px
}

@media (min-width: 480px) {

  :host(.hero-slider-child) {
    height: 326px
  }
}

@media (min-width: 640px) {

  :host(.hero-slider-child) {
    height: 360px
  }
}

@media (min-width: 768px) {

  :host(.hero-slider-child) {
    margin-top: 30px
  }

  :host(.hero-slider-child) {
    height: 250px
  }
}

@media (min-width: 1024px) {

  :host(.hero-slider-child) {
    margin-top: 0px
  }

  :host(.hero-slider-child) {
    height: 440px
  }
}



`;